import type { Price} from "../prices/price";
import { priceFactory, zeroPrice } from "../prices/price";
import { sumPrices } from "../prices/sum-prices";
import type { OrderItem_V1 } from "./order-items/order-item-v1";
import type { OrderItem_V2 } from "./order-items/order-item-v2";

type OrderPrices = {
    price: Price;
    tipPrice: Price;
    totalPrice: Price;
    extraOrderFee: Price;
};

const calculateOrderPrices = (
    orderItems: (OrderItem_V1 | OrderItem_V2)[],
    tip: number,
    providerMinDeliveryLimit: Price,
): OrderPrices => {
    const price = sumPrices(orderItems.map(oi => oi.price));
    const tipPrice = tip
        ? priceFactory({
              amountIncludingVat: price.amountIncludingVat * tip,
              vat: 0,
          })
        : zeroPrice;

    let totalPrice = sumPrices([price, tipPrice]);

    let extraOrderFee = zeroPrice;

    if (
        totalPrice.amountIncludingVat <
        providerMinDeliveryLimit.amountIncludingVat
    ) {
        extraOrderFee = priceFactory({
            amountIncludingVat:
                providerMinDeliveryLimit.amountIncludingVat -
                totalPrice.amountIncludingVat,
        });
        totalPrice = sumPrices([price, tipPrice, extraOrderFee]);
    }

    return {
        price,
        tipPrice,
        totalPrice,
        extraOrderFee,
    };
};

export { calculateOrderPrices };
export type { OrderPrices };
